import { QueryKey } from '@tanstack/react-query';
import apiClient from '../../../services/apiClient';
import {
  DirectGoodsFilter,
  DirectGoodsRequest,
  DirectGoodsResponse,
} from '../types';
import { TransformFilters } from '../../../utils';

export const DirectGoodsReqAPI = {
  gets: async ({
    queryKey,
  }: {
    queryKey: QueryKey;
  }): Promise<DirectGoodsResponse> => {
    const [, filters] = queryKey as [string, DirectGoodsFilter?];
    const transformedFilters = TransformFilters(filters);
    const response = await apiClient.get(
      '/api/petition/direct-consumer-good-request',
      {
        params: {
          ...transformedFilters,
          paginate: true,
          page: filters?.page,
        },
      }
    );

    return response.data;
  },

  get: async (petition_id: number): Promise<DirectGoodsRequest> => {
    const response = await apiClient.get(
      `/api/petition/direct-consumer-good-request/${petition_id}`
    );
    return response.data;
  },

  downloadFiles: async (petition_id: number): Promise<void> => {
    try {
      const response = await apiClient.get<Blob>(
        `/api/petition/direct-consumer-good-request/${petition_id}/documents`,
        {
          responseType: 'blob',
        }
      );

      const zipBlob = response as unknown as Blob;
      const url = window.URL.createObjectURL(zipBlob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `bienes_exportados.zip`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error: any) {
      throw error;
    }
  },

  downloadPDF: async (petition_id: number): Promise<void> => {
    try {
      const { data } = await apiClient.get(
        `/api/petition/direct-consumer-good-request/${petition_id}/voucher`
      );
      const { url: fileUrl, filename = 'Comprobante_de_solicitud.pdf' } =
        data || {};

      if (!fileUrl) throw new Error('No se encontró la URL del documento.');

      const blob = await (await fetch(fileUrl)).blob();
      const downloadUrl = URL.createObjectURL(blob);

      const link = Object.assign(document.createElement('a'), {
        href: downloadUrl,
        download: filename,
      });

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(downloadUrl);
    } catch (error) {
      throw error;
    }
  },

  acceptDelivery: async (petition_id: number, body: any) => {
    const response = await apiClient.post(
      `/api/petition/direct-consumer-good-request/${petition_id}/accept`,
      body
    );

    return response.data;
  },

  rejectDelivery: async (petition_id: number, body: any) => {
    const response = await apiClient.post(
      `/api/petition/direct-consumer-good-request/${petition_id}/reject`,
      body
    );

    return response.data;
  },

  generateDeliveryToken: async (petition_id: number) => {
    const response = await apiClient.post(
      `/api/petition/direct-consumer-good-request/${petition_id}/request-signature-token`,
      {}
    );
    return response.data;
  },
};
